'use client';
import { jsx } from 'react/jsx-runtime';
import { useMemo, useEffect } from 'react';
import { transformToLowercaseLocale, ALL_SUPPORTED_LOCALES } from '../../../core/constants/i18n.js';
import { SwanI18nProvider } from '../i18n/swan-i18n-provider.component.js';
import { SwanContext } from './swan-provider.context.js';
import { createSwanGlobalObject, createSwanVersionMetaTag } from '../../../core/utilities/swan-version.js';
import { loadSwanPolyfill } from '../../../core/utilities/load-polyfill.js';
import { getSwanBaseUrl } from '../../../core/utilities/base-url.utils.js';
import { SwanPathTypeEnum } from '../../../core/types/enums.js';

createSwanVersionMetaTag();
let d = SwanPathTypeEnum.hashed;
const SwanProvider = ({ swanBaseUrl: n, pathType: s, swanPathType: w, swanTenant: f, swanLocale: v, globalLinkComponent: u, children: h, translations: x })=>{
    let P = n || getSwanBaseUrl(f, v), y = w || s || d, B = useMemo(()=>({
            globalLinkComponent: u,
            swanBaseUrl: P,
            swanPathType: y,
            swanTenant: f,
            swanLocale: v
        }), [
        u,
        P,
        y,
        f,
        v
    ]), S = useMemo(()=>{
        if (!v || 'string' != typeof v) return false;
        let r = transformToLowercaseLocale(v);
        return ALL_SUPPORTED_LOCALES.includes(r);
    }, [
        v
    ]);
    if (x && !S) throw Error('`swanLocale` must be a valid locale when `translations` are provided');
    return useEffect(()=>{
        createSwanGlobalObject(B.swanBaseUrl);
    }, [
        B.swanBaseUrl
    ]), useEffect(()=>{
        loadSwanPolyfill(P);
    }, [
        P
    ]), jsx(SwanContext.Provider, {
        value: B,
        children: S && x ? jsx(SwanI18nProvider, {
            locale: v,
            translations: x,
            children: h
        }) : h
    });
};
SwanProvider.displayName = 'SwanProvider';

export { SwanProvider };
